const GRID_STYLE_PROPS_DATA = {
  rowGap: { type: "spacing", property: "rowGap" }
};

export { GRID_STYLE_PROPS_DATA };
